import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useEditor, useNode } from '@craftjs/core';

import PaddingStyle from '@resolvers/tools/PaddingStyle/PaddingStyle';
import ColorButtons from '@resolvers/tools/ColorButtons/ColorButtons';

import SettingsWrapper from '@common/components/SettingsWrapper/SettingsWrapper';
import SettingsRow from '@common/components/SettingsWrapper/SettingsRow';
import { EDITOR_RESOLVERS } from '@common/constants';
import {
  isNodeEmailContainerColumn,
  isNodeEmailContainerRow,
} from '@common/helpers/helpers';

const TemplateEmail = ({
  background,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  children,
}) => {
  const { actions } = useEditor();
  const {
    connectors: { connect, drag },
    actions: { setCustom },
  } = useNode();

  const ref = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (ref?.current) {
      connect(drag(ref.current));
    }
  }, []);

  useEffect(() => {
    actions.history.ignore(() => {
      setCustom((props) => {
        props.displayName = t('email_template');
      });
    });
  }, [setCustom, t]);

  return (
    <table
      ref={ref}
      width='100%'
      cellPadding='0'
      cellSpacing='0'
      border='0'
      role='presentation'
      style={{
        height: 'auto',
        minHeight: '400px',
        backgroundColor: `${background}`,
      }}
    >
      <tbody>
        <tr>
          <td
            align='left'
            valign='top'
            bgcolor='#ffffff'
            style={{
              paddingLeft: `${paddingLeft || 0}px`,
              paddingRight: `${paddingRight || 0}px`,
              paddingTop: `${paddingTop || 0}px`,
              paddingBottom: `${paddingBottom || 0}px`,
              height: 'auto',
              minHeight: '400px',
              width: '600px',
              backgroundColor: `${background}`,
            }}
          >
            {children}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export const TemplateConfigPanel = () => {
  return (
    <SettingsWrapper>
      <SettingsRow>
        <PaddingStyle />
      </SettingsRow>
      <SettingsRow>
        <ColorButtons hide={{ textColor: true }} />
      </SettingsRow>
    </SettingsWrapper>
  );
};

export const TemplateDefaultProps = {
  background: '#ffffff',
  children: null,
  paddingLeft: '5',
  paddingRight: '5',
  paddingTop: '10',
  paddingBottom: '10',
};

TemplateEmail.defaultProps = TemplateDefaultProps;

TemplateEmail.propTypes = {
  background: PropTypes.string,
  paddingLeft: PropTypes.string,
  paddingRight: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
  children: PropTypes.node,
};

TemplateEmail.craft = {
  displayName: EDITOR_RESOLVERS.EMAIL.TEMPLATE,
  name: EDITOR_RESOLVERS.EMAIL.TEMPLATE,
  props: TemplateDefaultProps,
  related: {
    settings: TemplateConfigPanel,
  },
  rules: {
    canMoveIn: (incomingNodes) => {
      return incomingNodes.every((node) => {
        return (
          !isNodeEmailContainerRow(node) && !isNodeEmailContainerColumn(node)
        );
      });
    },
  },
};

export default TemplateEmail;
